export const isEU = window.location.hostname.indexOf("eu") !== -1;

export const currencyCaption = isEU ? "€" : "$";

const currentYear = new Date().getFullYear();
const startYear = 1925;

export const years = "z"
  .repeat(currentYear - startYear + 1)
  .split("")
  .map((item, index) => index + startYear);

export const quantities = "z"
  .repeat(100)
  .split("")
  .map((item, index) => index + 1);

export const serviceLevels = {
  "psa-100": {
    label: "Value",
    turnaroundTime: "8-12 Weeks",
    maxDeclaredValue: 500,
    price: 29,
    time: "Economy / Value",
    logo: "/images/psa.png",
    disabled: false,
  },
};

export const evaluatePrice = 7;

export const evaluateSlabPrice = 20;

export const contactEmail = "info@gmsubs.com";

export const paypalEmail = contactEmail;

export const cashAppUser = "$stuartandchloe";

export const venmoUserName = "Ronald-Testa-4";

export const zellePhoneOrEmail = "732-337-7262";

export const totalSubsImages = 105;

export const subsImages = "z"
  .repeat(totalSubsImages)
  .split("")
  .map((_, index) => `/images/subs/${totalSubsImages - index}-n.jpg`);

const totalEvalImages = 12;

export const evalImages = "z"
  .repeat(totalEvalImages)
  .split("")
  .map((_, index) => `/images/eval${totalEvalImages - index}.jpg`);

export const twitterScreenName = "GMS_reviews";

export const videoId = "VXPszbFNFu4";
